/**
 * An automated or manual TEST run, marked so it never reads as a real visitor (2026-10-04).
 *
 * On 2026-10-03 a journey test ran with a real ad's utm_content and an fbclid and pressed Build with
 * the owner's account: in the log it was ad traffic, and it may have reached Meta. A visit opened with
 * `test=1` in its address is now a test for the rest of the tab: every first-party event carries
 * `test: true`, and the Meta pixel does not load at all.
 */
const KEY = 'saddle.test';

export function isTestVisit(): boolean {
  try {
    if (typeof location !== 'undefined' && new URLSearchParams(location.search).get('test') === '1') {
      sessionStorage.setItem(KEY, '1');
      return true;
    }
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
